import { render, staticRenderFns } from "./MappingDeleteDialog.vue?vue&type=template&id=c26785a2&scoped=true&"
import script from "./MappingDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./MappingDeleteDialog.vue?vue&type=script&lang=js&"
import style0 from "./MappingDeleteDialog.vue?vue&type=style&index=0&id=c26785a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26785a2",
  null
  
)

export default component.exports